module.exports = __webpack_public_path__ + "static/media/应用图片3_03.cb137181.png";